import React from 'react';

export function Panel({ children, style }) {
  return (
    <div
      style={{
        background: '#fff',
        boxShadow: '0 1px 1px rgba(0, 0, 0, .3)',
        padding: 24,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
